import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white flex items-center page-top-spacing">
      <div className="container-standard px-4 py-12 max-w-4xl">
        <div className="bg-white rounded-2xl shadow-xl p-12 text-center border border-gray-100">
          <h1 className="text-display font-bold text-primary-dark mb-4">404</h1>
          <h2 className="text-heading font-semibold text-gray-800 mb-4">Página no encontrada</h2>
          <p className="text-xl text-gray-600 mb-8">
            Lo sentimos, la página que estás buscando no existe.
          </p>
          <Link 
            to="/" 
            className="inline-block bg-primary-dark hover:bg-[#0d1c32] text-white font-semibold py-3 px-6 rounded-lg transition duration-300"
          >
            Volver al inicio
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;